import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Grid,
  Typography,
  TextField,
  Button,
  MenuItem
} from "@material-ui/core";

import {
  cmoUpdateRMAvailability,
  cmoFetchRMAvailability,
  cmoFetchRMStatusList
} from "../../../../../containers/actions/cmo/addRmPmActions";

class UpdateRMAvailability extends Component {
  state = {
    rmAvailabilityDetails: this.props.rmAvailabilityDetails,
    rmStatuses: [],
    errors: {
      rawMaterialName: "",
      units: "",
      requiredQuantity: "",
      shortage: "",
      statusCode: "",
      expectedDelivery: ""
    }
  };

  componentDidMount() {
    let data = { ...this.props.params, collabType: "CMO" };
    this.props.cmoFetchRMStatusList(data);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.rmUpdated === true) {
      let data = { ...this.props.params, collabType: "CMO" };
      setTimeout(() => this.props.cmoFetchRMAvailability(data), 2000);
      // this.props.cmoFetchRMAvailability(data);
      this.props.closeUpdate();
    }
    if (nextProps.rmStatuses) {
      this.setState({ rmStatuses: nextProps.rmStatuses });
    }
  }
  handleChange = e => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      rmAvailabilityDetails: {
        ...prevState.rmAvailabilityDetails,
        [name]: value
      },
      errors: {
        rawMaterialName: "",
        units: "",
        requiredQuantity: "",
        shortage: "",
        statusCode: "",
        expectedDelivery: ""
      }
    }));
  };

  handleBlur = (e) => {
    const { name, value } = e.target;
    // Only trim leading and trailing spaces for string values
    if (typeof value === "string" && value.trim() !== value) {
      const trimmedValue = value.trim();
      this.setState(prevState => ({
        rmAvailabilityDetails: {
          ...prevState.rmAvailabilityDetails,
          [name]: trimmedValue
        }
      }));
    }
  };

  validate = () => {
    let isError = false;

    let { rmAvailabilityDetails } = this.state;

    let errors = {
      rawMaterialName: "",
      units: "",
      requiredQuantity: "",
      shortage: "",
      statusCode: "",
      expectedDelivery: ""
    };

    if (rmAvailabilityDetails.rawMaterialName === "") {
      isError = true;
      errors.rawMaterialName = "Please Enter Material rawMaterialName";
    } else if (rmAvailabilityDetails.units === "") {
      isError = true;
      errors.units = "Please Enter Units";
    } else if (rmAvailabilityDetails.requiredQuantity === "") {
      isError = true;
      errors.requiredQuantity = "Please Enter Required Quantity";
    } else if (rmAvailabilityDetails.shortage === "") {
      isError = true;
      errors.shortage = "Please Enter Shortage Quantity";
    } else if (rmAvailabilityDetails.statusCode === "") {
      isError = true;
      errors.statusCode = "Please Select Status";
    } else if (rmAvailabilityDetails.expectedDelivery === "") {
      isError = true;
      errors.expectedDelivery = "Please Select Expected Delivery date";
    } else {
      this.setState({ alltrue: true });
    }
    this.setState({ errors });
    return isError;
  };

  onSubmit = () => {
    let error = this.validate();
    if (!error) {
      this.setState({ disableSaveButton: true });
      let data = {
        ...this.props.params,
        collabType: "CMO",
        RMAvailabilityData: this.state.rmAvailabilityDetails
      };
      this.props.cmoUpdateRMAvailability(data);
    }
  };

  clearData = () => {
    this.setState({
      disableSaveButton: false,
      rmAvailabilityDetails: {
        rawMaterialName: "",
        units: "",
        requiredQuantity: "",
        shortage: "",
        statusCode: "",
        expectedDelivery: ""
      }
    });
  };

  render() {
    const { rmAvailabilityDetails } = this.state;
    return (
      <Grid container spacing={1}>
        <Grid item xs={12} md={2}>
          <TextField
            label="Name"
            name="rawMaterialName"
            disabled
            fullWidth
            value={rmAvailabilityDetails.rawMaterialName}
            margin="normal"
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} md={1}>
          <TextField
            label="Batch Size"
            name="units"
            // disabled
            fullWidth
            value={rmAvailabilityDetails.units}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            margin="normal"
            variant="outlined"
            error={this.state.errors.units === "" ? false : true}
            helperText={this.state.errors.units}
          />
        </Grid>

        <Grid item xs={12} md={2}>
          <TextField
            label="Required Quantity"
            name="requiredQuantity"
            fullWidth
            value={rmAvailabilityDetails.requiredQuantity}
            onChange={this.handleChange}
            margin="normal"
            variant="outlined"
            error={this.state.errors.requiredQuantity === "" ? false : true}
            helperText={this.state.errors.requiredQuantity}
          />
        </Grid>

        <Grid item xs={12} md={1}>
          <TextField
            label="Shortage"
            name="shortage"
            fullWidth
            value={rmAvailabilityDetails.shortage}
            onChange={this.handleChange}
            margin="normal"
            variant="outlined"
            error={this.state.errors.shortage === "" ? false : true}
            helperText={this.state.errors.shortage}
          />
        </Grid>

        <Grid item xs={12} md={2}>
          <TextField
            label="Status"
            select
            fullWidth
            name="statusCode"
            value={rmAvailabilityDetails.statusCode}
            onChange={this.handleChange}
            margin="normal"
            variant="outlined"
          >
            {/* <MenuItem value={rmAvailabilityDetails.status}>
              {rmAvailabilityDetails.status}
            </MenuItem> */}
            {this.state.rmStatuses.map((ele, i) => (
              <MenuItem value={ele.statusCode} key={i}>
                {ele.statusText}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} md={2}>
          <TextField
            label={
              <Typography variant="caption" style={{ fontSize: "0.65rem" }}>
                Expected Days for Delivery
              </Typography>
            }
            select
            fullWidth
            name="expectedDelivery"
            value={rmAvailabilityDetails.expectedDelivery}
            onChange={this.handleChange}
            margin="normal"
            variant="outlined"
            error={this.state.errors.expectedDelivery === "" ? false : true}
            helperText={this.state.errors.expectedDelivery}
          >
            <MenuItem value={"0"}>0</MenuItem>
            <MenuItem value={"5"}>5</MenuItem>
            <MenuItem value={"10"}>10</MenuItem>
            <MenuItem value={"15"}>15</MenuItem>
            <MenuItem value={"20"}>20</MenuItem>
            <MenuItem value={"25"}>25</MenuItem>
            <MenuItem value={"30"}>30</MenuItem>
          </TextField>
        </Grid>

        <Grid
          item
          xs={12}
          md={2}
          style={{
            display: "flex",
            justifyContent: "center",
            // marginTop: "1rem",
            alignItems: "center"
          }}
        >
          <Button
            variant="contained"
            // color="primary"
            disabled={this.state.disableSaveButton}
            onClick={this.onSubmit}
            style={{
              color: "#ffffff",
              backgroundColor: this.state.disableSaveButton ? "grey" : "green"
            }}
          >
            Save
          </Button>

          <Typography
            variant="body2"
            color="error"
            onClick={this.props.closeUpdate}
            style={{
              paddingLeft: "1rem",
              cursor: "pointer"
            }}
          >
            Cancel X
          </Typography>
        </Grid>
      </Grid>
    );
  }
}
const mapStatetoProps = state => ({
  rmUpdated: state.pcmp.cmo.rmpm.rmUpdated,
  rmStatuses: state.pcmp.cmo.rmpm.rmStatuses
});
export default connect(mapStatetoProps, {
  cmoUpdateRMAvailability,
  cmoFetchRMAvailability,
  cmoFetchRMStatusList
})(UpdateRMAvailability);
